import React, { useState, useEffect } from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import ThreeStory from "../three-story";
import BigWithSmallStoryMobile from "../big-with-small-story-mobile";

import { getCollectionSlug } from "../../utils/utils";
import { getFitStories } from "../../helper/api";

import "./twoCollectionWithTwoStories.m.css";

const TwoCollectionWithTwoStories = ({ collection, sections, fitUrl, pageType }) => {
  if (!(collection && collection.items)) {
    return null;
  }

  const collectionList = collection.items.filter((item) => item.type === "collection" && item.items);
  if (!collectionList.length) {
    return null;
  }

  const [firstCollection, secondCollection] = collectionList;

  const secondCollectionItems = secondCollection && secondCollection.items;
  const firstCollectionItems = firstCollection && firstCollection.items;

  const [firstCollectionStories, setFirstCollectionStories] = useState(firstCollectionItems);
  const [secondCollectionStories, setSecondCollectionStories] = useState(secondCollectionItems);
  const [firstExternalSlug, setFirstExternalSlug] = useState("");
  const [secondExternalSlug, setSecondExternalSlug] = useState("");
  const [isFirstExternalStory, setFirstExternalStory] = useState(false);
  const [isSecondExternalStory, setSecondExternalStory] = useState(false);

  useEffect(() => {
    setUpExternalCollection(firstCollection, "first");
    secondCollection && setUpExternalCollection(secondCollection);
  }, []);

  const setUpExternalCollection = (collection, type) => {
    if (collection.template === "external-collection") {
      const slug = get(collection, ["metadata", "external-collection-slug"], "home");
      getFitStories(slug).then((data) => {
        if (type === "first") {
          setFirstCollectionStories(data.items);
          setFirstExternalSlug(`${fitUrl}/${slug}`);
          setFirstExternalStory(true);
        } else {
          setSecondCollectionStories(data.items);
          setSecondExternalSlug(`${fitUrl}/${slug}`);
          setSecondExternalStory(true);
        }
      });
    }
  };

  return (
    <div id={collection.slug} className="container">
      <div styleName="desktop">
        <ThreeStory
          list={firstCollectionStories.filter((item) => item.type === "story").map((item) => item.story)}
          collectionName={firstCollection.name}
          collectionSlug={isFirstExternalStory ? firstExternalSlug : getCollectionSlug(firstCollection, sections)}
          isExternalStory={isFirstExternalStory}
        />

        {secondCollection && secondCollectionStories && secondCollectionStories.length ? (
          <ThreeStory
            list={secondCollectionStories.filter((item) => item.type === "story").map((item) => item.story)}
            collectionName={secondCollection.name}
            collectionSlug={isSecondExternalStory ? secondExternalSlug : getCollectionSlug(secondCollection, sections)}
            isExternalStory={isSecondExternalStory}
          />
        ) : null}
      </div>

      <div styleName="mobile">
        <BigWithSmallStoryMobile
          collection={firstCollection}
          isExternalStory={isFirstExternalStory}
          externalSlug={firstExternalSlug}
          externalStories={firstCollectionStories || []}
        />
        {secondCollection && secondCollectionStories && secondCollectionStories.length ? (
          <BigWithSmallStoryMobile
            collection={secondCollection}
            isExternalStory={isSecondExternalStory}
            externalSlug={secondExternalSlug}
            externalStories={secondCollectionStories || []}
          />
        ) : null}
      </div>
    </div>
  );
};

TwoCollectionWithTwoStories.propTypes = {
  collection: object.isRequired,
  sections: array,
  fitUrl: string,
  pageType: string,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  pageType: get(state, ["qt", "pageType"], null),
  fitUrl: get(state, ["qt", "config", "publisher-attributes", "fit_page_url"], null),
});

export default connect(mapStateToProps, null)(TwoCollectionWithTwoStories);
